import { Client } from "../../clients/client";
import {
  ErrorEventFilterForm,
  ErrorNotificationIdilterForm
} from "./forms/ErrorEventFilterForm";
import { ErrorEvent } from "./models/ErrorEvent";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";

export class ErrorEventUseCase {
  constructor(private client: Client) {}

  public async filterErrorNotification(
    queryData: ErrorEventFilterForm,
    form: PaginationForm
  ): Promise<Pagination<ErrorEvent>> {
    return this.client.notification.getErrorNotification(queryData, {
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  public async getErrorItemById(id: number): Promise<ErrorEvent> {
    return this.client.notification.getOneError(id);
  }

  public async getAllErrorEvent(
    queryData: ErrorNotificationIdilterForm,
    form: PaginationForm
  ): Promise<Pagination<ErrorEvent>> {
    return this.client.notification.getErrorEvent(queryData, {
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  public async updateAcknowledgement(id: number) {
    return this.client.notification.updateAcknowledgementById(id);
  }
}
